export default (params) => ({
  trigger: {
    name: 'wishlist.copy_wishlist_url',
    params: params,
  },
  config: {
    schema: {
      status: {
        type: 'string',
        example_value: 'success',
      },
      url_type: {
        type: 'string',
        example_value: 'product',
      },
      link_url: {
        type: 'string',
        example_value: 'https://example.com/product/12345',
      },
    },
    event: {
      name: 'copy_url',
      params: {
        sub_feature: null,
      },
    },
  },
});
